import {createContext, useContext, useState, ReactNode} from "react";

interface ModalContextType {
  modalOpen: boolean;
  modalTitle: string;
  isLoading: boolean;
  openModal: (title: string, onConfirm: () => void) => void;
  closeModal: () => void;
  confirmHandler: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({children}: {children: ReactNode}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(
    () => {}
  );
  const [isLoading, setIsLoading] = useState(false);

  const openModal = (title: string, onConfirm: () => void) => {
    setModalTitle(title);
    setOnConfirmCallback(() => onConfirm);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setIsLoading(false);
  };

  const confirmHandler = async () => {
    setIsLoading(true);
    onConfirmCallback();
  };

  return (
    <ModalContext.Provider
      value={{
        modalOpen,
        modalTitle,
        isLoading,
        openModal,
        closeModal,
        confirmHandler,
      }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error("useModal must be used within a ModalProvider");
  return context;
};
